<script lang="ts">
    import { Button, Col, Nav, NavLink, NavItem } from "sveltestrap";
    import { SectionandSeparator, href, Dashboard, Widgets, Layout, Sidebar, PageLayout, Footers, LogOut, General } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import FeatherIcon from "svelte-feather-icon";
    import Dropdownsection from "./Dropdownsection.svelte";
</script>
<Col md="6">
    <Card cardHeaderprops="pb-0" cardProps="height-equal" headerTitle={SectionandSeparator}>
        <div slot="contentbody">
          <ul class="icon-lists border navs-icon">
            <li>
              <h5 class="mb-0">{General}</h5>
            </li>
            <Nav vertical>
                <NavItem>
                    <FeatherIcon icon="home" />
                    <span>{Dashboard}</span>
                </NavItem>
                <NavItem>
                    <FeatherIcon icon="airplay" />
                    <span>{Widgets}</span>
                </NavItem>
            </Nav>
            <li>
                <h5 class="mb-0">{Layout}</h5>
            </li>
            <Nav vertical>
                <NavItem >
                    <FeatherIcon icon="sidebar" />
                    <span> {Sidebar}</span>
                </NavItem>
                <NavItem>
                    <FeatherIcon icon="layout" />
                    <span>{PageLayout}</span>
                </NavItem>
                <NavItem >
                    <FeatherIcon icon="cloud-lightning" />
                    <span> {Footers}</span>
                </NavItem>
                <li class="separator"></li>
                <li class="pt-0">
                  <Button class="btn-pill btn-outline-primary" color="">{LogOut}</Button>
                </li>
            </Nav>
          </ul>
          <Dropdownsection/>
        </div>
    </Card>
</Col>